// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item_table_gs1bp{border-bottom:.1rem solid var(--cp-gray-5)}.item_table__wrap_i7ctI{margin-top:auto;padding-top:2.4rem}.item_table__tr_\\+p\\+U2:not(:last-child){border-bottom:none}.item_table__td_VDxN4,.item_table__th_4jnB7{color:var(--cp-black);font-size:1.2rem;line-height:1.4rem;padding:0;text-align:center;width:25%}.item_table__td_VDxN4:not(:last-child),.item_table__th_4jnB7:not(:last-child){border-right:.1rem solid var(--cp-gray-5)}.item_table__th_4jnB7{background-color:var(--cp-gray-6);height:3rem;text-transform:capitalize}.item_table__td_VDxN4{height:4rem;padding:0 .4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item_table": "item_table_gs1bp",
	"item_table__wrap": "item_table__wrap_i7ctI",
	"item_table__tr": "item_table__tr_+p+U2",
	"item_table__td": "item_table__td_VDxN4",
	"item_table__th": "item_table__th_4jnB7"
};
module.exports = ___CSS_LOADER_EXPORT___;
